import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  planTitle: {
    fontSize: 24,
    // color: Colors.largeTextColor,
    fontWeight: "bold",
  },
  greenTitle: {
    fontSize: 20,
    // color: Colors.primaryGreenColor,
    fontWeight: "bold",
  },
  container: {
    flex: 1,
    backgroundColor: "white",
  },
  labelText: {
    // color: Colors.sectionTextColor,
    fontSize: 16,
    marginBottom: 6,
  },
  labelTextBold: {
    // color: Colors.sectionTextColor,
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 6,
  },
  valueText: {
    // color: Colors.textColor,
    fontSize: 16,
    lineHeight: 24,
  },
  mainContainer: {
    flex: 1,
    paddingHorizontal: 24,
  },
  avatarImg: {
    width: 40,
    height: 40,
    marginHorizontal: 24,
  },
  rowContainer: {
    flexDirection: "row",
    paddingVertical: 16,
    alignItems: "center",
  },
  bodyText: {
    fontSize: 16,
    fontWeight: "normal",
    // color: Colors.textColor
  },
  roleText: {
    fontSize: 12,
    // color: Colors.textColor
  },
  nameText: {
    fontSize: 16,
    fontWeight: "600",
    //  color: Colors.largeTextColor
  },
  bottomContainer: {
    paddingHorizontal: 20,
    bottom: 40,
  },
  contentContainer: {
    paddingBottom: 40,
  },
  headerImg: {
    width: "100%",
    height: "40%",
  },
  sectionTitle: {
    fontSize: 20,
    // color: Colors.largeTextColor,
    fontWeight: "bold",
  },
  itemContainer: {
    marginVertical: 16,
  },
  itemRowContainer: {
    display: "flex",
    flexDirection: "row",
    marginVertical: 16,
  },
  sportImg: {
    marginRight: 12,
  },
  descriptionText: {
    // color: Colors.greyTextColor,
    fontSize: 20,
    fontWeight: "500",
  },
  startBtn: {
    // backgroundColor: Colors.primaryGreenColor,
    height: 48,
    borderRadius: 8,
  },
  startText: { fontSize: 18, fontWeight: "500", color: "white" },
});

export default styles;
